import axios, { AxiosHeaders, AxiosError } from 'axios'
import { validateTokens } from '../helpers/getTokens.helper'
import { handleApiError } from '../utils/api-error-handler'

const TrackProAPI = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
})

TrackProAPI.interceptors.request.use(async (config) => {
    const { accessToken, graphToken } = await validateTokens();
    (config.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);
    (config.headers as AxiosHeaders).set("refresh_token", graphToken as string);
    
    // Prevent caching
    (config.headers as AxiosHeaders).set("Cache-Control", "no-cache, no-store, must-revalidate");
    
    return config;
});

// Response interceptor for global error handling
TrackProAPI.interceptors.response.use(
    (response) => {
        // Return successful response as-is
        return response;
    },
    (error: AxiosError) => {
        // Check if the error should be handled globally
        // Skip global handling if the request has a custom header to opt-out
        const skipGlobalHandling = error.config?.headers?.['skip-global-error'] === 'true';
        if (!skipGlobalHandling) {
            handleApiError(error);
        }
        
        // Always reject the promise so components can still handle errors locally if needed
        return Promise.reject(error);
    }
);

export default TrackProAPI;

export const apiMarketPlace = process.env.REACT_APP_API_MARKET_PLACE ?? '';
